module.exports = __webpack_public_path__ + "static/img/IMG_20240523_211723-EFFECTS.84108737.jpg";